import { render, staticRenderFns } from "./Reposicao.vue?vue&type=template&id=24e75d13&"
import script from "./Reposicao.vue?vue&type=script&lang=js&"
export * from "./Reposicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports